module.exports = __webpack_public_path__ + "img/qrcode.pubacc.2296acd7.png";